import { useTranslation } from 'react-i18next';
import { Badge } from '@ui/badge.tsx';
import { cn } from '@r/utils/utils.ts';

/** Associe couleur du point et clé i18n à partir du statut brut renvoyé par l'API. */
function getStatusStyles(status: string | null | undefined) {
  if (!status) {
    return { dotClass: 'bg-muted-foreground', labelKey: null };
  }

  if (status.includes('planned')) {
    return { dotClass: 'bg-blue-500', labelKey: status };
  }

  if (status.includes('active')) {
    return { dotClass: 'bg-emerald-600', labelKey: status };
  }

  if (status.includes('finished')) {
    return { dotClass: 'bg-muted-foreground', labelKey: status };
  }

  return { dotClass: 'bg-muted-foreground', labelKey: status };
}

/** Badge de statut affiché en tête de chaque carte booster. */
export function BoosterStatusBadge({ status }: { status: string | null | undefined }) {
  const { t } = useTranslation();
  const { dotClass, labelKey } = getStatusStyles(status);

  return (
    <Badge variant="outline" className="gap-1.5 border-muted-foreground/20 font-normal">
      <span className={cn('size-1.5 shrink-0 rounded-full', dotClass)} aria-hidden />
      {labelKey ? t(labelKey) : t('boosters.status.unknown')}
    </Badge>
  );
}
